import { AppState } from '../../../../types'

const selectors = {
  getAll: (state: AppState) => state.monitoring.cloudHubSettings,
  isLoadingEnvironments: (state: AppState) => selectors.getAll(state).environmentSelector.isLoading,
  environments: (state: AppState) => selectors.getAll(state).environmentSelector.environments,
  selectedEnvironment: (state: AppState) => selectors.getAll(state).environmentSelector.selected,
  isNewAppsAgentEnabled: (state: AppState) => {
    const cloudHubDeployment = selectors.getAll(state).cloudHubDeployment
    return cloudHubDeployment ? cloudHubDeployment.deployment.newAppsAgentEnabled : undefined
  },
  isLoadingCHSettings: (state: AppState) => {
    const cloudHubDeployment = selectors.getAll(state).cloudHubDeployment
    return cloudHubDeployment ? cloudHubDeployment.isLoading : false
  },
  isChangingCHSettings: (state: AppState) => {
    const cloudHubDeployment = selectors.getAll(state).cloudHubDeployment
    return cloudHubDeployment ? cloudHubDeployment.isChanging : true
  },
  isLoadingResources: (state: AppState) => selectors.getAll(state).resourceList.isLoading,
  resources: (state: AppState) => selectors.getAll(state).resourceList.resources,
  filteredResources: (state: AppState) => selectors.getAll(state).resourceList.filteredResources,
  applyStatus: (state: AppState) => selectors.getAll(state).applyStatus,
  applyEnableMonitoringStatus: (state: AppState) => selectors.getAll(state).enableMonitoringStatus,
  query: (state: AppState) => selectors.getAll(state).query,
}

export default selectors
